import axios from 'axios'
import store from '../../store'
// Define base url
const BASE_URL = '/api/v1/expenses'

// Define expenses module
const expenses = {
  state: {
    data: {},
    errors: {}
  },
  getters: {
    expensesCollection: state => {
      return state.data
    }
  },
  mutations: {
    setExpensesErrors (state, payload) {
      state.errors = payload
    },
    getExpensesData (state, payload) {
      state.data = payload
    },
    deleteInvoiceData (state, payload) {
      let index = state.data.data[payload.index].items.findIndex(i => i.id === payload.id)
      state.data.data[payload.index].items.splice(index, 1)
    }
  },
  actions: {
    async expensesShowData ({ commit }, payload) {
      try {
        const response = await axios.get(BASE_URL +'/'+ payload)
        if (response.status === 200) {
          commit('getExpensesData', response.data)
        }
      } catch (error) {
        commit('setExpensesErrors', error)
      }
    },
    async expensesStore ({ commit }, payload) {
      try {
        const response = await axios.post(BASE_URL, payload)
        if (response.status === 201) {
          return response.data.data
        }
      } catch (error) {
        commit('setExpensesErrors', error.response.data)
      }
    },
    async expensesUpdate ({ commit }, payload) {
      try {
        const response = await axios.put(`${BASE_URL}/${payload.id}`, payload)
        if (response.status === 202) {
          return response.data.data
        }
      } catch (error) {
        commit('setExpensesErrors', error.response.data)
      }
    },
    async expensesDestroy ({ commit }, payload) {
      try {
        const response = await axios.delete(`${BASE_URL}/${payload.id}`, payload)
        if (response.status === 204) {
          commit('deleteExpenseData', payload)
        }
      } catch (error) {
        Promise.reject(error)
      }
    }
  }
}

// Export the expenses module
export default expenses
